import { render, staticRenderFns } from "./KanbanColumn.vue?vue&type=template&id=62e5c450&scoped=true"
import script from "./KanbanColumn.vue?vue&type=script&lang=js"
export * from "./KanbanColumn.vue?vue&type=script&lang=js"
import style0 from "./KanbanColumn.vue?vue&type=style&index=0&id=62e5c450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e5c450",
  null
  
)

export default component.exports